const getters = {
  workMachines: state => state.work_machines,
  workMachine: state => state.work_machine,
  workMachineCosts: state => state.work_machine_costs,
  workMachineCost: state => state.work_machine_cost,
  workMachineCostTypes: state => state.work_machine_cost_types,
}

export default getters;
